import React, { Component } from "react";
import ReactTooltip from "react-tooltip";
import { Link } from "react-router-dom";
import JejakinLogo from "./../../../gogreener_carbon_offset_jejakin.svg";
import JejakinLogoGoGreener from "./../../../gogreener_jejakin.svg";
import ErrorVector from "./../../../images/offline.svg";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import jjk_planting from "./../../../images/superhero.svg";
import icon_tree from "./../../../images/icon/tree.png";
import icon_2023 from "./../../../images/icon/2023.svg";
import icon_2023_disabled from "./../../../images/icon/2023-disabled.svg";
import icon_2024 from "./../../../images/icon/2024.svg";
import icon_2024_disabled from "./../../../images/icon/2024-disabled.svg";
import icon_2025 from "./../../../images/icon/2025.svg";
import icon_2025_disabled from "./../../../images/icon/2025-disabled.svg";
import icon_2026 from "./../../../images/icon/2026.svg";
import icon_2026_disabled from "./../../../images/icon/2026-disabled.svg";
import icon_2030 from "./../../../images/icon/2030.svg";
import icon_2030_disabled from "./../../../images/icon/2030-disabled.svg";
import icon_info from "./../../../images/icon/info.svg";
import icon_sun from "./../../../images/icon/sun.svg";
import icon_cstock from "./../../../images/icon/icon_cstock.svg";
import icon_jejak from "./../../../images/icon/jejak.png";
import NumberFormat from "react-number-format";
import axios from "axios";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Profile.scss";
import ContentLoader from "react-content-loader";
import { Translation } from "react-i18next";
import ProgramMapArea from "./ProgramMapArea";
import ProgramArea from "./ProgramArea";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import "react-tabs/style/react-tabs.css";

import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Pagination } from "swiper";
import "swiper/swiper.scss";
import "swiper/components/pagination/pagination.scss";
SwiperCore.use([Pagination]);

// https://github.com/lucasmogari/google-map-react-example
// Google Map Polygon

// Map Open Layer
// https://dominoc925.blogspot.com/2019/10/simple-example-of-reactjs-and.html

const CardLoaderFull = () => (
  <ContentLoader height={170}>
    <rect x="0" y="0" rx="6" ry="6" width="100%" height="140" />
  </ContentLoader>
);

const CardLoaderBox = () => (
  <ContentLoader height={120}>
    <rect x="0" y="0" rx="6" ry="6" width="100%" height="100" />
  </ContentLoader>
);

const CardLoader = () => (
  <ContentLoader height={320}>
    <rect x="0" y="0" rx="6" ry="6" width="100%" height="220" />
    <rect x="0" y="230" rx="6" ry="6" width="300" height="12" />
    <rect x="0" y="250" rx="6" ry="6" width="300" height="16" />
    <rect x="0" y="275" rx="6" ry="6" width="50" height="12" />
  </ContentLoader>
);

function SeparatorNumber(lang, number, decimal) {
  if (lang === "en") {
    return (
      <React.Fragment>
        <NumberFormat
          value={number}
          displayType={"text"}
          thousandSeparator={","}
          decimalSeparator={"."}
          decimalScale={decimal}
          className="black"
        />
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        <NumberFormat
          value={number}
          displayType={"text"}
          thousandSeparator={"."}
          decimalSeparator={","}
          decimalScale={decimal}
          className="black"
        />
      </React.Fragment>
    );
  }
}

function SeparatorValue(lang, value) {
  // return <GuestGreeting / > ;
  var val;
  if (value >= 1000000) {
    val = value / 1000000;
  } else if (value >= 9999.999 && value < 1000000) {
    val = value / 1000;
  } else {
    val = value;
  }
  if (lang === "en") {
    if (value >= 1000000) {
      return (
        <React.Fragment>
          <NumberFormat
            value={val}
            displayType={"text"}
            thousandSeparator={","}
            decimalSeparator={"."}
            decimalScale={1}
          />
        </React.Fragment>
      );
    } else if (value >= 9999.999 && value < 1000000) {
      return (
        <React.Fragment>
          <NumberFormat
            value={val}
            displayType={"text"}
            thousandSeparator={","}
            decimalSeparator={"."}
            decimalScale={0}
          />
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <NumberFormat
            value={val}
            displayType={"text"}
            thousandSeparator={","}
            decimalSeparator={"."}
            decimalScale={0}
          />
        </React.Fragment>
      );
    }
  } else {
    if (value >= 1000000) {
      return (
        <React.Fragment>
          <NumberFormat
            value={val}
            displayType={"text"}
            thousandSeparator={"."}
            decimalSeparator={","}
            decimalScale={1}
          />
        </React.Fragment>
      );
    } else if (value >= 9999.999 && value < 1000000) {
      return (
        <React.Fragment>
          <NumberFormat
            value={val}
            displayType={"text"}
            thousandSeparator={"."}
            decimalSeparator={","}
            decimalScale={0}
          />
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <NumberFormat
            value={val}
            displayType={"text"}
            thousandSeparator={"."}
            decimalSeparator={","}
            decimalScale={0}
          />
        </React.Fragment>
      );
    }
  }
}

function UnitValue(lang, value) {
  if (lang === "en") {
    if (value <= 9999.999) {
      return "gCO2e";
    } else if (value <= 1000000) {
      return "kgCO2e";
    } else {
      return "tCO2e";
    }
  } else {
    if (value <= 9999.999) {
      return "gCO2e";
    } else if (value <= 1000000) {
      return "kgCO2e";
    } else {
      return "tCO2e";
    }
  }
}

function convertToDate(dateValue) {
  const dateObject = new Date(dateValue);
  const day = dateObject.getDate();
  const month = dateObject.toLocaleString("default", { month: "short" });
  const year = dateObject.getFullYear();

  return `${day} ${month} ${year}`;
}

class ProfileProgramContribution extends Component {
  constructor(props) {
    super(props);
    this.map = {};
    this.state = {
      status: true,
      loggedIn: false,
      errorState: false,
      errors: [],
      loaderButton: false,
      loading: true,
      userid: null,
      programid: null,
      user: {},
      cstock: {},
      treeGrowth: [],
      treeGrowthCarbon: [],
      lang: "en",
      programDetail: {},
      programGeneral: {},
      programImages: [],
      bounds: null,
      blockProgram: null,
      blockProgramName: null,
      blockArea: 0,
      showingInfoWindow: false,
      activeMarker: {},
      selectedPlace: {},
      listProgramTreeSummary: [],
      center: {
        lat: -6.2731154,
        lng: 106.723221,
      },
      zoom: 11,
      loc_id: null,
      date: null,
      type: "drone",
      id_group: 1,
      hide_else: false,
      weather: null,
      droneId: null,
      // droneSummary: {},
      loadingMap: true,
    };
  }

  componentDidMount() {
    this.setState({
      lang: window.localStorage.i18nextLng,
      userid: this.props.match.params.idprofile,
      programid: this.props.match.params.idprogram,
    });
    this.getBlockProgram();
    this.getDroneContainer(this.props.match.params.idprogram);
    //this.getDroneSummary(this.props.match.params.idprogram);
    this.getTransactionDetail(
      this.props.match.params.idprofile,
      this.props.match.params.idprogram
    );
    this.getTransactionCstockDetail(
      this.props.match.params.idprofile,
      this.props.match.params.idprogram
    );
    this.getProgramDetail(
      this.props.match.params.idprogram,
      this.props.match.params.idprofile
    );
    this.getAnnualTreeGrowthDiameter(
      this.props.match.params.idprofile,
      this.props.match.params.idprogram
    );
    this.getAnnualTreeGrowthCarbon(
      this.props.match.params.idprofile,
      this.props.match.params.idprogram
    );
    this.getWeather(this.props.match.params.idprogram);
    // this.getDroneLayer(this.props.match.params.idprogram, this.props.match.params.idprofile)
  }

  getDroneContainer = (idprogram) => {
    axios
      .get(
        process.env.REACT_APP_API_HOST + "/profile/drone-container/" + idprogram
      )
      .then((res) => {
        if (res.data.status) {
          console.log("drone container", res.data);
          if (res.data.data.droneList.length !== 0) {
            //console.log("droneId not null");
            this.setState({
              droneId: res.data.data.droneList[0].id,
              loadingMap: false,
            });
          } else {
            console.log("droneId null");
            this.setState({
              droneId: null,
              loadingMap: false,
            });
          }
        }
      });
  };

  // getDroneSummary = (idprogram) => {
  //   axios
  //     .get(
  //       process.env.REACT_APP_API_HOST + "/profile/drone-summary/" + idprogram
  //     )
  //     .then((res) => {
  //       if (res.data.status) {
  //         console.log("drone summary", res.data);
  //         this.setState({
  //           droneSummary: res.data.data,
  //           loading: false,
  //         });
  //       }
  //     });
  // };

  getTransactionDetail = (idprofile, idprogram) => {
    axios
      .get(
        process.env.REACT_APP_API_HOST +
          "/profile/transactions-summary/" +
          idprofile +
          "/" +
          idprogram
      )
      .then(
        (res) => {
          if (res.data.status) {
            console.log("res transaction detail ", res.data);
            this.setState({
              user: res.data.data,
            });
          } else {
            this.setState({
              errorState: true,
              errors: res.data.errors,
            });
          }
        },
        (error) => {
          console.log("error", error);
          setTimeout(() => {
            this.setState({
              errorState: true,
              errors: error.response.data.errors,
            });
          }, 1000);
        }
      );
  };
  getTransactionCstockDetail = (idprofile, idprogram) => {
    axios
      .get(
        process.env.REACT_APP_API_HOST +
          "/profile/transactions-cstock/" +
          idprofile +
          "/" +
          idprogram
      )
      .then(
        (res) => {
          if (res.data.status) {
            console.log("res cstock detail ", res.data);
            this.setState({
              cstock: res.data.data,
            });
          } else {
            this.setState({
              errorState: true,
              errors: res.data.errors,
            });
          }
        },
        (error) => {
          console.log("error", error);
          setTimeout(() => {
            this.setState({
              errorState: true,
              errors: error.response.data.errors,
            });
          }, 1000);
        }
      );
  };
  getAnnualTreeGrowthDiameter = (idprofile, idprogram) => {
    axios
      .get(
        process.env.REACT_APP_API_HOST +
          "/profile/annual-tree-diameter/" +
          idprofile +
          "/" +
          idprogram
      )
      .then(
        (res) => {
          if (res.data.status) {
            console.log("res annual tree diameter ", res.data);
            this.setState({
              treeGrowth: res.data.data,
            });
          } else {
            this.setState({
              errorState: true,
              errors: res.data.errors,
            });
          }
        },
        (error) => {
          console.log("error", error);
          setTimeout(() => {
            this.setState({
              errorState: true,
              errors: error.response.data.errors,
            });
          }, 1000);
        }
      );
  };
  getAnnualTreeGrowthCarbon = (idprofile, idprogram) => {
    axios
      .get(
        process.env.REACT_APP_API_HOST +
          "/profile/annual-tree-carbon/" +
          idprofile +
          "/" +
          idprogram
      )
      .then(
        (res) => {
          if (res.data.status) {
            console.log("res annual tree carbon ", res.data);
            this.setState({
              treeGrowthCarbon: res.data.data,
            });
          } else {
            this.setState({
              errorState: true,
              errors: res.data.errors,
            });
          }
        },
        (error) => {
          console.log("error", error);
          setTimeout(() => {
            this.setState({
              errorState: true,
              errors: error.response.data.errors,
            });
          }, 1000);
        }
      );
  };
  getProgramDetail = (idprogram, idprofile) => {
    axios
      .get(
        process.env.REACT_APP_API_HOST +
          "/program/detail/" +
          idprogram +
          "/" +
          idprofile
      )
      .then(
        (res) => {
          console.log("res program detail ", res.data);
          if (res.data.status) {
            this.setState(
              {
                programDetail: res.data.data,
                programImages: res.data.data.programImages,
                listProgramTreeSummary: res.data.data.listProgramTreeSummary,
                gogreener: res.data.data.tags
                  ? res.data.data.tags.includes("Planting") ||
                    res.data.data.tags.includes("planting")
                    ? "planting"
                    : res.data.data.tags.includes("Adoption") ||
                      res.data.data.tags.includes("adoption")
                    ? "adoption"
                    : res.data.data.tags.includes("tree collective") ||
                      res.data.data.tags.includes("tree_collective")
                    ? "tree_collective"
                    : "gogreener"
                  : "planting",
              },
              () => {
                this.getProgramGeneral(idprogram);
              }
            );
          } else {
            this.setState({
              errorState: true,
              errors: res.data.errors,
            });
          }
        },
        (error) => {
          console.log("error", error);
          setTimeout(() => {
            this.setState({
              errorState: true,
              errors: error.response.data.errors,
            });
          }, 1000);
        }
      );
  };

  getWeather = (idprogram) => {
    axios
      .get(process.env.REACT_APP_API_HOST + "/program/weather/" + idprogram)
      .then(
        (res) => {
          if (res.data.status) {
            this.setState({
              weather: res.data.data,
            });
          } else {
            this.setState({
              errorState: true,
              errors: res.data.errors,
            });
          }
        },
        (error) => {
          console.log("error", error);
          setTimeout(() => {
            this.setState({
              errorState: true,
              errors: error.response.data.errors,
            });
          }, 1000);
        }
      );
  };

  getProgramGeneral = (idprogram) => {
    axios
      .get(process.env.REACT_APP_API_HOST + "/program/general/" + idprogram)
      .then(
        (res) => {
          if (res.data.status) {
            console.log("detail", res.data);
            this.setState({
              programGeneral: res.data.data,
              loading: false,
            });
          } else {
            this.setState({
              errorState: true,
              errors: res.data.errors,
            });
          }
        },
        (error) => {
          console.log("error", error);
          setTimeout(() => {
            this.setState({
              errorState: true,
              errors: error.response.data.errors,
            });
          }, 1000);
        }
      );
  };

  getBlockProgram = () => {
    axios
      .get(
        process.env.REACT_APP_API_HOST +
          "/program/block/" +
          this.props.match.params.idprogram
      )
      .then(
        (res) => {
          console.log("res blok", res.data);
          if (res.data.status) {
            this.setState({
              blockProgram: res.data.data[0].coordinate,
              blockProgramName: res.data.data[0].name,
              blockArea: res.data.data[0].area,
            });
          } else {
            this.setState({
              errorState: true,
              errors: res.data.errors,
            });
          }
        },
        (error) => {
          console.log("error", error);
          setTimeout(() => {
            this.setState({
              errorState: true,
              errors: error.response.data.errors,
            });
          }, 1000);
        }
      );
  };

  openTreeSummary = (treeid) => {
    window.location =
      "/profile/" +
      this.props.match.params.idprofile +
      "/" +
      treeid +
      "/tree-history";
  };

  openSensorData = () => {
    window.location =
      "/profile/" +
      this.props.match.params.idprofile +
      "/" +
      this.props.match.params.idprogram +
      "/sensor";
  };

  render() {
    const { treeGrowth, treeGrowthCarbon } = this.state;
    return (
      <>
        <div className="header no-print">
          <div className="nav nav-main-top">
            <div className="container">
              <div className="row">
                <div className="col-sm-12">
                  <div className="logo-img">
                    {this.state.gogreener === "tree_collective" ? (
                      <>
                        <img src={JejakinLogoGoGreener} alt="Jejak.in" />
                      </>
                    ) : (
                      <>
                        <img src={JejakinLogo} alt="Jejak.in" />
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mpl-page">
          {this.state.errorState ? (
            <>
              <div className="modal-error active">
                <div className="modal">
                  <span
                    className="modal-close"
                    onClick={() => {
                      this.setState({
                        errorState: false,
                        errors: null,
                      });
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </span>
                  <div className="modal-content">
                    <img src={ErrorVector} alt="Error" className="mb-20" />
                    <h3 className="tx-center">
                      <Translation>
                        {(t, { i18n }) => <>{t(this.state.errors[0].code)}</>}
                      </Translation>
                    </h3>
                  </div>
                </div>
              </div>
            </>
          ) : null}
          <ToastContainer />
          {this.state.loading ? (
            <div className="container">
              <div className="row">
                <div className="col-sm-12">
                  <br />
                  <br />
                  <CardLoaderFull />
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <CardLoaderBox />
                  <br />
                </div>
                <div className="col-12">
                  <CardLoaderBox />
                  <br />
                </div>
                <div className="col-12">
                  <CardLoaderBox />
                </div>
              </div>
              <br />
              <div className="row">
                <div className="col-12">
                  <CardLoader />
                </div>
              </div>
            </div>
          ) : (
            <Translation>
              {(t, { i18n }) => (
                <div className="container">
                  <div className="row">
                    <div className="col-12">
                      <ul className="breadcrumb">
                        <li className="breadcrumb-item">
                          <Link
                            to={"/profile/" + this.props.match.params.idprofile}
                          >
                            {t("Report")}
                          </Link>
                        </li>
                        <li className="breadcrumb-item active">
                          <span>{t("ReportDetail")}</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="card card-custom">
                        <div className="text-card">
                          <h4>
                            {t("Hi")}{" "}
                            <span className="tx-capitalize">
                              {this.state.user.userName}
                            </span>
                          </h4>
                          <p className="text-overview mb-0">
                            {t("WeHavePlantedYourTrees")}
                          </p>
                          <p className="text-overview mb-0 mt-2">
                            {t("ThisIsTheTreePlantingReport")}
                          </p>
                        </div>
                        <img
                          src={jjk_planting}
                          className="img-float"
                          alt="GoGreener"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-sm-12">
                      <h2 className="title-page mt-0 mb-0">
                        {this.state.programDetail.title}
                      </h2>
                      <div className="wrapper-slide">
                        {this.state.programImages.length !== 0 ? (
                          <>
                            <Swiper
                              pagination={{ clickable: true }}
                              spaceBetween={5}
                              centeredSlides={true}
                              onSwiper={(swiper) =>
                                console.log("Onboarding loaded")
                              }
                            >
                              <SwiperSlide key={"FEATUREDIMAGE"}>
                                <div className="swiper-slide swiper-radius small">
                                  <div className="img-wrap">
                                    <LazyLoadImage
                                      effect="blur"
                                      src={
                                        process.env.REACT_APP_IMAGE_PROGAM +
                                        "/image/program/" +
                                        this.state.programDetail.featuredImage
                                      }
                                      className="img-responsive rad-10"
                                      alt={this.state.programDetail.title}
                                    />
                                  </div>
                                </div>
                              </SwiperSlide>
                              {this.state.programImages.map((img, idx) => {
                                return (
                                  <SwiperSlide key={idx}>
                                    <div className="swiper-slide swiper-radius small">
                                      <div className="img-wrap">
                                        <LazyLoadImage
                                          effect="blur"
                                          src={
                                            process.env.REACT_APP_IMAGE_PROGAM +
                                            "/image/program/" +
                                            img
                                          }
                                          className="img-responsive rad-10"
                                          alt="Program Images"
                                        />
                                      </div>
                                    </div>
                                  </SwiperSlide>
                                );
                              })}
                            </Swiper>
                          </>
                        ) : (
                          <div className="swiper-slide swiper-radius small">
                            <div className="img-wrap">
                              <img
                                src={
                                  process.env.REACT_APP_IMAGE_PROGAM +
                                  "/image/program/" +
                                  this.state.programDetail.featuredImage
                                }
                                className="img-responsive rad-10"
                                alt=""
                              />
                            </div>
                          </div>
                        )}
                      </div>
                      <h3>{t("MyProgramContributions")}</h3>
                      <div
                        className="card card-white"
                        style={{ marginBottom: "30px" }}
                      >
                        <div className="card-icon">
                          <div className="icon mr-2">
                            <img src={icon_tree} alt="Tree" />
                          </div>
                          <div className="text">
                            <span className="note contribution">
                              {t("contribution")}
                            </span>
                            <h4 className="black">
                              {SeparatorNumber(
                                this.state.lang,
                                this.state.user.totalContribution,
                                2
                              )}{" "}
                              {t("Transactions")}
                            </h4>
                          </div>
                        </div>
                        <div className="card-icon">
                          <div className="icon mr-2">
                            <img src={icon_tree} alt="Tree" />
                          </div>
                          <div className="text">
                            <span className="note contribution">
                              {t("Planted")}
                            </span>
                            <h4 className="black">
                              {SeparatorNumber(
                                this.state.lang,
                                this.state.user.totalTreePlanting,
                                2
                              )}{" "}
                              {t("Trees")}
                            </h4>
                          </div>
                        </div>
                        <div className="card-icon">
                          <div className="icon mr-2">
                            <img src={icon_cstock} alt="Sequestration" />
                          </div>
                          <div className="text">
                            <span className="note contribution">
                              {this.state.cstock.lastDate === null
                                ? t("EstimatedCstokAfterTreePlanted")
                                : t("EstimatedCstokAfterDate", {
                                    date: convertToDate(
                                      this.state.cstock.lastDate
                                    ),
                                  })}
                            </span>
                            <h4 className="black">
                              {/* {SeparatorNumber(
                                this.state.lang,
                                this.state.cstock.totalLastDateCarbonEmission,
                                2
                              )}
                              &nbsp;
                              {
                                this.state.cstock
                                  .totalLastDateCarbonEmissionUnit
                              } */}
                              {SeparatorValue(
                                this.state.lang,
                                this.state.cstock.totalLastDateCarbonEmission *
                                  1000000
                              )}
                              &nbsp;
                              {UnitValue(
                                this.state.lang,
                                this.state.cstock.totalLastDateCarbonEmission *
                                  1000000
                              )}
                            </h4>
                          </div>
                          <div className="ml-1">
                            <div style={{ position: "relative" }}>
                              <img
                                src={icon_info}
                                data-tip
                                data-for="tooltip"
                                alt="tooltip"
                                width={"18px"}
                                height={"18px"}
                                style={{ position: "absolute", top: "2px" }}
                              />
                            </div>

                            <ReactTooltip
                              className="tooltip"
                              id="tooltip"
                              place="left"
                              type="dark"
                              effect="solid"
                              getContent={() => t("Estimatedcarbonstockdesc")}
                              arrow="center"
                            />
                          </div>
                        </div>
                        <div className="card-icon">
                          <div className="icon mr-2">
                            <img src={icon_cstock} alt="Sequestration" />
                          </div>
                          <div className="text">
                            <span className="note contribution">
                              {t("EstimatedCstok8Lifespan")}
                            </span>
                            <h4 className="black">
                              {/* {SeparatorNumber(
                                this.state.lang,
                                this.state.cstock.totalCarbonEmissionLifespan,
                                2
                              )}
                              &nbsp;
                              {
                                this.state.cstock
                                  .totalCarbonEmissionLifespanUnit
                              } */}
                              {SeparatorValue(
                                this.state.lang,
                                this.state.cstock.totalCarbonEmissionLifespan *
                                  1000000
                              )}
                              &nbsp;
                              {UnitValue(
                                this.state.lang,
                                this.state.cstock.totalCarbonEmissionLifespan *
                                  1000000
                              )}
                            </h4>
                          </div>
                          <div className="ml-1">
                            <div style={{ position: "relative" }}>
                              <img
                                src={icon_info}
                                data-tip
                                data-for="Estimatedcarbonstockin8yearsdesc"
                                alt="tooltip"
                                width={"18px"}
                                height={"18px"}
                                style={{ position: "absolute", top: "2px" }}
                              />
                            </div>

                            <ReactTooltip
                              className="tooltip"
                              id="Estimatedcarbonstockin8yearsdesc"
                              place="left"
                              type="dark"
                              effect="solid"
                              getContent={() =>
                                t("Estimatedcarbonstockin8yearsdesc")
                              }
                              arrow="center"
                            />
                          </div>
                        </div>
                      </div>

                      <h3>{t("SensorData")}</h3>
                      <div className="card card-white">
                        <div className="card-icon">
                          <div className="icon">
                            <img src={icon_sun} alt="Sun" />
                          </div>
                          <div className="text text-single">
                            <h4 className="temperature">
                              {this.state.weather ? (
                                <>
                                  {SeparatorNumber(
                                    this.state.lang,
                                    this.state.weather.main.temp,
                                    2
                                  )}{" "}
                                  <sup>o</sup> C
                                </>
                              ) : (
                                <>
                                  N/A <sup>o</sup> C{" "}
                                </>
                              )}
                            </h4>
                            <span className="temperature">
                              {t("Temperature")}
                            </span>
                          </div>
                          <div className="button-wrap">
                            <Link
                              to={
                                "/profile/" +
                                this.props.match.params.idprofile +
                                "/" +
                                this.props.match.params.idprogram +
                                "/sensor?program=" +
                                this.state.gogreener
                              }
                              className="button"
                            >
                              {t("seedetail")}
                            </Link>
                          </div>
                        </div>
                      </div>
                      <h3>{t("ProgramInformation")}</h3>
                      <div className="program-information-wrap">
                        {/* <p className="program-information">
                          {t("ConservationPartner")}
                        </p>
                        {this.state.programDetail.conservationPartners
                          .length === 0 ? (
                          "N/A"
                        ) : (
                          <>
                            {" "}
                            <div className="card-icon">
                              <div className="icon">
                                <img
                                  src={
                                    process.env.REACT_APP_IMAGE_PROGAM +
                                    "/image/corporate-user-images/" +
                                    this.state.programDetail
                                      .conservationPartners[0].logo
                                  }
                                  alt="Conservation Partner"
                                />
                              </div>
                              <div
                                className="text"
                                style={{ paddingBottom: "0" }}
                              >
                                <h4 className="mitra">
                                  {
                                    this.state.programDetail
                                      .conservationPartners[0].name
                                  }
                                </h4>
                                <span className="mitra">Verified</span>
                              </div>
                            </div>
                          </>
                        )} */}
                        <div
                          className="program-content-wrap"
                          dangerouslySetInnerHTML={{
                            __html: this.state.programDetail.description,
                          }}
                        ></div>
                      </div>
                    </div>
                    <div className="col-sm-12">
                      <br />
                      <div className="card card-green">
                        <div className="card-icon">
                          <div className="icon">
                            <img src={icon_tree} alt="Tree" />
                          </div>
                          <div className="text">
                            <h4>
                              {this.state.lang === "id" ? (
                                <React.Fragment>
                                  {this.state.programGeneral.totalArea >
                                  10000 ? (
                                    <NumberFormat
                                      value={
                                        this.state.programGeneral.totalArea /
                                        10000
                                      }
                                      displayType={"text"}
                                      thousandSeparator={"."}
                                      decimalSeparator={","}
                                      decimalScale={2}
                                    />
                                  ) : (
                                    <NumberFormat
                                      value={
                                        this.state.programGeneral.totalArea
                                      }
                                      displayType={"text"}
                                      thousandSeparator={"."}
                                      decimalSeparator={","}
                                      decimalScale={2}
                                    />
                                  )}
                                </React.Fragment>
                              ) : (
                                <React.Fragment>
                                  {this.state.programGeneral.totalArea >
                                  10000 ? (
                                    <NumberFormat
                                      value={
                                        this.state.programGeneral.totalArea /
                                        10000
                                      }
                                      displayType={"text"}
                                      thousandSeparator={"."}
                                      decimalSeparator={","}
                                      decimalScale={2}
                                    />
                                  ) : (
                                    <NumberFormat
                                      value={
                                        this.state.programGeneral.totalArea
                                      }
                                      displayType={"text"}
                                      thousandSeparator={"."}
                                      decimalSeparator={","}
                                      decimalScale={2}
                                    />
                                  )}
                                </React.Fragment>
                              )}
                              &nbsp;
                              {this.state.programGeneral.totalArea > 10000 ? (
                                <>Ha</>
                              ) : (
                                <>
                                  m<sup>2</sup>
                                </>
                              )}
                            </h4>
                            <span>{t("TotalArea")}</span>
                          </div>
                        </div>
                        <div className="card-icon">
                          <div className="icon">
                            <img src={icon_tree} alt="Tree" />
                          </div>
                          <div className="text">
                            <h4>
                              {this.state.lang === "id" ? (
                                <NumberFormat
                                  value={this.state.programGeneral.totalTree}
                                  displayType={"text"}
                                  thousandSeparator={"."}
                                  decimalSeparator={","}
                                  decimalScale={0}
                                />
                              ) : (
                                <NumberFormat
                                  value={this.state.programGeneral.totalTree}
                                  displayType={"text"}
                                  thousandSeparator={","}
                                  decimalSeparator={"."}
                                  decimalScale={0}
                                />
                              )}{" "}
                              {t("Tree(s)")}
                            </h4>
                            <span>{t("TotalNumberOfTrees")}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    {this.state.cstock.lifespan < 4 ||
                    this.state.treeGrowthCarbon.length === 0 ? (
                      <></>
                    ) : (
                      <div className="col-sm-12">
                        <h3>{t("Programinsight")}</h3>
                        <div className="card card-white">
                          <div
                            className="d-flex justify-content-between align-items-center border-bottom pb-3"
                            style={{ borderColor: "#E0E0E0" }}
                          >
                            <h3 className="annual-title">
                              {t("Annualtreegrowth")}
                            </h3>
                            <img
                              src={icon_info}
                              data-tip
                              data-for="annualGrowth"
                              alt="tooltip"
                              width={"18px"}
                              height={"18px"}
                            />
                            <ReactTooltip
                              className="tooltip"
                              id="annualGrowth"
                              place="left"
                              type="dark"
                              effect="solid"
                              getContent={() => t("Annualgrowthdesc")}
                              arrow="left"
                            />
                          </div>
                          <div className="my-3">
                            <Tabs>
                              <TabList className="custom-tablist">
                                <Tab className="custom-tab annual">tCO2e</Tab>
                                <Tab className="custom-tab annual">
                                  Diameter
                                </Tab>
                              </TabList>

                              <TabPanel>
                                <div className="d-flex align-items-end justify-content-around background-annual mt-3">
                                  {treeGrowthCarbon
                                    .slice(0, 4)
                                    .concat(treeGrowthCarbon.slice(-1))
                                    .map((data, index) => {
                                      let iconSrc = "";

                                      if (index === 0) {
                                        iconSrc = data.isActive
                                          ? icon_2023
                                          : icon_2023_disabled;
                                      } else if (index === 1) {
                                        iconSrc = data.isActive
                                          ? icon_2024
                                          : icon_2024_disabled;
                                      } else if (index === 2) {
                                        iconSrc = data.isActive
                                          ? icon_2025
                                          : icon_2025_disabled;
                                      } else if (index === 3) {
                                        iconSrc = data.isActive
                                          ? icon_2026
                                          : icon_2026_disabled;
                                      } else {
                                        iconSrc = data.isActive
                                          ? icon_2030
                                          : icon_2030_disabled;
                                      }
                                      return (
                                        <div
                                          className="d-flex flex-column align-items-center justify-content-end"
                                          key={data.year}
                                        >
                                          <p className="value-annual-chart">
                                            {SeparatorValue(
                                              this.state.lang,
                                              data.carbonEmission * 1000000
                                            )}
                                            &nbsp;
                                            {UnitValue(
                                              this.state.lang,
                                              data.carbonEmission * 1000000
                                            )}
                                          </p>
                                          <img src={iconSrc} alt="img" />
                                          <p
                                            style={{
                                              fontSize: "10px",
                                              color: "#A3A3A3",
                                            }}
                                          >
                                            {index === 4 ? (
                                              <span>{t("Targetin")}</span>
                                            ) : (
                                              ""
                                            )}
                                            <span> {data.year}</span>
                                          </p>
                                        </div>
                                      );
                                    })}
                                </div>
                              </TabPanel>
                              <TabPanel>
                                <div className="d-flex align-items-end justify-content-around background-annual mt-3">
                                  {treeGrowth
                                    .slice(0, 4)
                                    .concat(treeGrowth.slice(-1))
                                    .map((data, index) => {
                                      let iconSrc = "";

                                      if (index === 0) {
                                        iconSrc = data.isActive
                                          ? icon_2023
                                          : icon_2023_disabled;
                                      } else if (index === 1) {
                                        iconSrc = data.isActive
                                          ? icon_2024
                                          : icon_2024_disabled;
                                      } else if (index === 2) {
                                        iconSrc = data.isActive
                                          ? icon_2025
                                          : icon_2025_disabled;
                                      } else if (index === 3) {
                                        iconSrc = data.isActive
                                          ? icon_2026
                                          : icon_2026_disabled;
                                      } else {
                                        iconSrc = data.isActive
                                          ? icon_2030
                                          : icon_2030_disabled;
                                      }
                                      return (
                                        <div
                                          className="d-flex flex-column align-items-center justify-content-end"
                                          key={data.year}
                                        >
                                          <p className="value-annual-chart">
                                            {SeparatorNumber(
                                              this.state.lang,
                                              data.diameter,
                                              1
                                            )}{" "}
                                            cm
                                          </p>
                                          <img src={iconSrc} alt="img" />
                                          <p
                                            style={{
                                              fontSize: "10px",
                                              color: "#A3A3A3",
                                            }}
                                          >
                                            {index === 4 ? (
                                              <span>{t("Targetin")} </span>
                                            ) : (
                                              ""
                                            )}
                                            <span>{data.year}</span>
                                          </p>
                                        </div>
                                      );
                                    })}
                                </div>
                              </TabPanel>
                            </Tabs>
                          </div>
                        </div>
                      </div>
                    )}
                    {this.state.loadingMap === true ? null : (
                      <div className="col-sm-12">
                        <h3>{t("ProgramArea")}</h3>
                        {this.state.blockProgram ? (
                          <ProgramMapArea
                            program={this.state.programid}
                            user={this.state.userid}
                            block={this.state.blockProgram}
                            blockName={this.state.blockProgramName}
                            blockArea={this.state.blockArea}
                            drone={this.state.droneId}
                            //droneSummary={this.state.droneSummary}
                          />
                        ) : null}
                      </div>
                    )}
                  </div>
                  <div className="row">
                    <div className="col-sm-12">
                      <h3>{t("TreeDiversity")}</h3>
                      {this.state.listProgramTreeSummary.map((tree) => {
                        return (
                          <React.Fragment key={tree.id}>
                            <div
                              className="card card-white tes"
                              style={{ cursor: "pointer" }}
                            >
                              <div className="history-wrap">
                                <div className="history-title">
                                  <p
                                    style={{
                                      marginTop: "5px",
                                    }}
                                  >
                                    {t("TreeName")}
                                  </p>
                                  <p>{t("ScientificName")}</p>
                                  <p>{t("TotalTrees")}</p>
                                </div>
                                <div className="history-content">
                                  <p
                                    className="tx-capitalize"
                                    style={{
                                      marginTop: "5px",
                                    }}
                                  >
                                    {tree.treeName}
                                  </p>
                                  <p className="tx-capitalize">
                                    {tree.treeBinomialName}
                                  </p>
                                  <p>
                                    {this.state.lang === "id" ? (
                                      <NumberFormat
                                        value={tree.total}
                                        displayType={"text"}
                                        thousandSeparator={"."}
                                        decimalSeparator={","}
                                        decimalScale={0}
                                      />
                                    ) : (
                                      <NumberFormat
                                        value={tree.total}
                                        displayType={"text"}
                                        thousandSeparator={","}
                                        decimalSeparator={"."}
                                        decimalScale={0}
                                      />
                                    )}
                                  </p>
                                </div>
                              </div>
                              <div className="button-wrap wrap-normal">
                                <Link
                                  to={
                                    "/profile/" +
                                    this.props.match.params.idprofile +
                                    "/" +
                                    tree.id +
                                    "/tree-history?program=" +
                                    this.state.gogreener
                                  }
                                  className="button button-detail smooth"
                                >
                                  {t("ViewDetail")}
                                </Link>
                              </div>
                            </div>
                          </React.Fragment>
                        );
                      })}
                    </div>
                  </div>
                </div>
              )}
            </Translation>
          )}
        </div>
      </>
    );
  }
}

export default ProfileProgramContribution;
